

<!--  -------------------------------  Dump Report  Filters ------------------------ -->
<ion-row class="ion-align-items-center">
  <ion-col size="12" size-sm>
    <ion-row class="ion-align-items-center">
      <ion-col size="12" size-sm>
        <div class="phi-flex-wrap-center phi-gap-10">
          <!-- -------------------------------------- Year ---------------------------------------- -->
          <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="selectedYearForDWM" (selectionChange)="getYearSetupForDWM(selectedYearForDWM)">
             
              <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                {{ sharedService.transformYearToFyFormat(item.year) }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- -------------------------------------- Months ---------------------------------------- -->
          <mat-form-field class="w-100 mat-height40 mw-sm-150 mat-input-style">
            <mat-select placeholder="Select Month" [(ngModel)]="selectedMonthForDWM" (selectionChange)="changeReportsData()">
              <mat-option *ngFor="let month of filteredMonthsList" [value]="month">
                {{ month }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- -------------------------------- Plant Multiselect ------------------------------- -->
          <ng-multiselect-dropdown *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' " class="w-100 mw-sm-200 mat-height40 mat-input-style" [data]="plantList" [(ngModel)]="selectedPlants" [settings]="plantDropdownSettings" placeholder="Select Plant Location" (onSelect)="onPlantSelect()" (onDeSelect)="onPlantDeselect()"
           (onSelectAll)="onPlantSelectAll($event)" (onDeSelectAll)="onPlantDeSelectAll()"></ng-multiselect-dropdown>

                 <!-- -------------------------------- Department Multiselect ------------------------------- -->
          <ng-multiselect-dropdown *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin'" class="w-100 department-auto-width mw-sm-200 mat-height40 mat-input-style custom-multiselect" [data]="departmentsList" [(ngModel)]="selectedDepartments" [settings]="departmentDropdownSettings" 
          placeholder="Select Department" (onSelect)="onDepartmentSelect()" (onDeSelect)="onDepartmentDeselect()" (onSelectAll)="onDepartmentSelectAll($event)" 
          (onDeSelectAll)="onDepartmentDeSelectAll()"></ng-multiselect-dropdown>

          <!-- -------------------------------- Employee Dropdown For Super Admin & HR Admin------------------------------- -->
          <ng-multiselect-dropdown *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin'" class="w-100 department-auto-width mw-sm-200 mat-height40 mat-input-style" [data]="employeesList" [(ngModel)]="selectedEmployees" [settings]="employeeDropdownSettings" placeholder="Select Employee" (onSelect)="onEmployeeSelect()" (onDeSelect)="onEmployeeDeselect()" (onSelectAll)="onEmployeeSelectAll($event)" (onDeSelectAll)="onEmployeeDeSelectAll()"></ng-multiselect-dropdown>
  
        </div>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>

<!-- -------------------------------------- Dump  Report Data ---------------------------------------- -->

<div class="table-card-box mb-15" >
  <ion-row>
    <ion-col size>
      <div class="phi-flex-wrap-center phi-gap-12 mb-5" *ngIf="selectedEmployees && selectedEmployees.length > 0">
        <mat-form-field class="w-100 mw-sm-175 mat-height40 mat-input-style" >
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" (input)="onSearch($event)"  />
        </mat-form-field>     
      </div>
    </ion-col>
    <ion-col size="auto" >
      <div class="phi-flex-wrap-center phi-gap-12">
        <!-- <span class="hrs-and-achievement total-hours" *ngIf="checkIfIsRNDOrL4AndAboveEmployee?.isRnd">
          Total Hours Worked =
          <strong class="ml-5">{{ achievementTotalHrs?.totalHoursWorked || '00:00' }}</strong>
        </span>
        <span class="hrs-and-achievement achievment" *ngIf="achievementTotalHrs?.complianceScore">
          Achievement =
          <strong class="ml-5 ">{{ achievementTotalHrs?.complianceScore ?? 0 }}%</strong>
        </span> -->
        <!-- <button type="button" class="dwm_btn fs-14 fs_12ForMobile" *ngIf="selectedFilters?.selectedEmpId && userIsAdminTypes?.userIsAdmin" (click)="saveAllRecords(paginatedData)" [disabled]="!selectedFilters.selectedEmpId">Save All</button> -->

        <!-- <button *ngIf="userIsAdminTypes?.userIsAdmin" type="button" class="dwm_btn fs-14 fs_12ForMobile" (click)="addNewTask(paginatedData)">+ New DWM</button>
        <span *ngIf="dwmSkippDay.isSkipped" class="applied-skip-day" [innerHTML]="dwmSkippDay.isSkippedText"></span> -->
        <div class="download-btns phi-flex-wrap-center phi-gap-12" *ngIf="selectedEmployees && selectedEmployees.length > 0">
          <img src="assets/svg/pdf.svg" class="download-img-btn" (click)="downloadReport('pdf')" />
          <img src="assets/svg/excel.svg" class="download-img-btn" (click)="downloadReport('excel')" />
        </div>
      </div>
    </ion-col>
  </ion-row>

  <div class="table-container" *ngIf="selectedEmployees && selectedEmployees.length > 0">
    
    <table class="hover">
      <thead>
        <tr>
          <!-- <th class="mat-checkbox-style text-center">
            <mat-checkbox value="true" [(ngModel)]="isAllSelected" matTooltip="Select all tasks on this page" (change)="selectALLDwms($event, paginatedData)"></mat-checkbox>
          </th> -->
          <ng-container *ngFor="let item of teamTableHeaders; let i = index">
            <th class="fs-14 fs_12ForMobile font_bold cl-black sortable"  (click)="onSort(item.key)">
              <div class="verticle-center header-text justify-content-space-between icon-style">
                {{ item?.label }}
                
                <div class="sort-records-container d-flex flex-column ml-5">
                  <ion-icon name="caret-up-outline" [class.active]="tableState.sortColumn === item?.key && tableState.sortDirection === 'asc'"></ion-icon>
                  <ion-icon name="caret-down-outline" [class.active]="tableState.sortColumn === item?.key && tableState.sortDirection === 'desc'"></ion-icon>
                </div>
              </div>
            </th>
          </ng-container>
    
        </tr>
      </thead>

      <tbody >
     <tr *ngFor="let item of paginatedData" >  
        <td>{{ item.employeeId }}</td>
       <td>{{ item.employeeName }}</td>   
        <td>{{ item.plantLocation }}</td>
        <td>{{ item.department }}</td>
        <td>{{ item.grade }}</td>
        <td>{{ item.reportingManager }}</td>
        <td>{{ item.tasksSubmittedForApproval }}</td>
        <td>{{ item.tasksApprovedByManager }}</td>
        <td>{{ item.tasksRejectedByManager }}</td>
        <td>{{ item.tasksPendingFromManagerApproval }}</td>
        <td>{{ item.draftTasks }}</td>
        <td>{{ item.tasksDoneOnTime }}</td>
        <td>{{ item.tasksDoneWithDelay }}</td>
        <td>{{ item.tasksIncompleteAfterDueDate }}</td>
        <td>{{ item.tasksNotCompleted }}</td>
        <td>{{ item.complianceScore | number:'1.2-2' }}</td>
      
        </tr>
      </tbody>
    </table>
  </div>

  <div  *ngIf="!selectedEmployees || (selectedEmployees && selectedEmployees.length === 0)"  class="text-center p-20 fs-14">Please select an employee to view  records.</div>


    <div class="phi-flex-wrap-center-space-between-gap6 mt-10" *ngIf="totalEntries > 0">

  <ion-label  class="fs-14 fs_12ForMobile font_bold black_color">
    Showing {{ startEntry }} to {{ endEntry }} of {{ totalEntries }} entries
  </ion-label>

  <div class="phi-flex-wrap-center phi-gap-12">

    <div class="phi-flex-wrap-center phi-gap-8">
      <ion-label  class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>

      <mat-form-field class="w70px mat-height40 mat-input-style">
        <mat-select (selectionChange)="changePageSize($event.value)" [value]="pageSize">
          <mat-option [value]="10">10</mat-option>
          <mat-option [value]="25">25</mat-option>
          <mat-option [value]="50">50</mat-option>
          <mat-option [value]="100">100</mat-option>
        </mat-select>
      </mat-form-field>

      <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
    </div>

    <ul class="dt_pagination" >
      <li class="previous-page" (click)="changePage(currentPage - 1)" [class.disableBtn]="currentPage === 1">
        &lt;
      </li>

      <li class="active fs-16 fs_14ForMobile font_regular">
        {{ currentPage }}
      </li>

      <span class="fs-14 fs_12ForMobile font_regular p-10">of {{ totalPages }}</span>

      <li class="next-page"  (click)="changePage(currentPage + 1)" [class.disableBtn]="currentPage === totalPages">
        &gt;
      </li>
    </ul>

  </div>
</div>


</div>
